import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52869e38"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu-bar"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "menu-pop"
};
const _hoisted_4 = {
  class: "menu-pop-container"
};
const _hoisted_5 = ["onClick"];
import { ref, computed } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from "vuex";
import { navList } from "./constant";
export default {
  __name: 'index',
  props: {
    orgInfo: Object
  },
  setup(__props) {
    const store = useStore();
    const menusMap = computed(() => store.state.home.menusMap || {});
    let props = __props;
    const isActive = key => {
      let arr = route.path.split('/');
      return arr && arr.length && arr[1] === key;
    };
    let interval = null;
    const can = ref(true);
    const router = useRouter();
    const route = useRoute();
    const onClick = val => {
      if (!val.path || props.orgInfo.status !== 0) return;
      router.push(val.path);
      can.value = false;
      interval && clearTimeout(interval);
      interval = setTimeout(() => {
        can.value = true;
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.key
        }, [menusMap.value[item.icon] ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["menu-item", {
            active: isActive(item.key)
          }])
        }, [_createElementVNode("div", {
          class: "menu-item-inner",
          onClick: $event => onClick(item)
        }, [_createElementVNode("i", {
          class: _normalizeClass(`menu-icon ${item.icon}`)
        }, null, 2), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 8, _hoisted_2), item.path !== '/home' && item.children && can.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, subItem => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: subItem.name
          }, [menusMap.value[subItem.path] && !subItem.noRender ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "menu-pop-item",
            onClick: $event => onClick(subItem)
          }, [_createElementVNode("div", {
            class: _normalizeClass([`menu-pop-item-icon sub-menu-icon ${subItem.icon}`, ""])
          }, null, 2), _createElementVNode("span", null, _toDisplayString(subItem.name), 1)], 8, _hoisted_5)) : _createCommentVNode("", true)], 64);
        }), 128))])])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 64);
      }), 128))]);
    };
  }
};